import { createContext, useContext } from "react";
import { MODAL_LIST } from "./ModalRouter_list";

export type ModalStackItem = {
  k: string;
  s: keyof typeof MODAL_LIST;
  a: any;
}

export const ModalRouterContext = createContext<{
  modalStack: ModalStackItem[];
  pop: () => void;
  push: (modalConfig: Omit<ModalStackItem, 'k'>) => void;
}>({
  modalStack: [],
  pop: () => {},
  push: () => {},
});

export const useModalRouter = () => {
  return useContext(ModalRouterContext);
};
